import { Grid } from '@mui/material';
import { ClassNameMap, withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import {
  sessionDurationIcon,
  sessionEnergyIcon,
  sessionMoneyIcon,
} from '../../../assets/icons/icons';
import SessionItem from './session-item.component';
import { DetailsStyles } from './styles/detailsStyles';
import { readableDuration } from '../../../util/date-utils';
import { dataTestIds } from '../../../constant/dataTestId';

interface IProps {
  classes: ClassNameMap;
  session: {
    cost: number;
    consumedEnergyKilowattHours: number;
    pluggedInTimeSeconds: number;
  };
}

const ChargerSessionDetails = ({ classes, session }: IProps) => {
  const { i18n } = useTranslation();
  const { cost, consumedEnergyKilowattHours, pluggedInTimeSeconds } = session;
  const fixedPrice = (value) => value?.toFixed(2);

  return (
    <Grid container className={classes.root}>
      <Grid container className={classes.itemContainer}>
        <SessionItem
          label={i18n.t('duration')}
          details={readableDuration(pluggedInTimeSeconds)}
          Icon={sessionDurationIcon}
          ariaLabel={i18n.t('session_duration')}
        />
        <SessionItem
          label={i18n.t('energy')}
          details={`${Number(consumedEnergyKilowattHours ?? 0).toFixed(4)} kWh`}
          Icon={sessionEnergyIcon}
          ariaLabel={i18n.t('energy_dispensed')}
        />
        <SessionItem
          label={i18n.t('cost')}
          details={`$${fixedPrice(cost)}`}
          Icon={sessionMoneyIcon}
          ariaLabel={i18n.t('session_cost')}
          dataTestId={dataTestIds.chargerPage.completedSessionCostLabel}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(DetailsStyles)(ChargerSessionDetails);
